// extracted by mini-css-extract-plugin
module.exports = {"product-card":"filterstore_product-card__saHJh","accordion_header":"filterstore_accordion_header__krJ_M","actions":"filterstore_actions__4aTpG"};